import { EnhancedRadioGroupRHF, IEnhancedRadioGroupRHF } from "./EnhancedRadioGroupRHF";
import { FieldLayout, LabelPosition, LayoutWithLabel } from "@websential/cosmic-v20";
import React, { FC } from "react";

export interface IEnhancedRadioGroupRHFWithLabelAndDescription
  extends IEnhancedRadioGroupRHF,
  LayoutWithLabel { }

/**
 * RadioGroup is a helpful wrapper used to group Radio.
 * The EnhancedRadioGroup using the component EnhancedRadioButton.
 */
export const EnhancedRadioGroupRHFWithLabelAndDescription: FC<IEnhancedRadioGroupRHFWithLabelAndDescription> =
  ({
    name,
    selectedValue,
    disabled = false,
    readOnly = false,
    options,
    testId,
    displayAsRow = true,
    label,
    required,
    labelPosition = LabelPosition.Top,
    labelColumns,
    fieldColumns,
    onChangeHandler,
  }) => {
    return (
      <FieldLayout
        label={label}
        isRequired={required}
        testId={testId}
        labelPosition={labelPosition}
        labelColumns={labelColumns}
        fieldColumns={fieldColumns}
        fieldTopPadding={0.8}
      >
        <EnhancedRadioGroupRHF
          displayAsRow={displayAsRow}
          testId={testId}
          name={name}
          selectedValue={selectedValue}
          options={options}
          disabled={disabled}
          readOnly={readOnly}
          onChangeHandler={onChangeHandler}
        />
      </FieldLayout>
    );
  };
